import React from 'react';
import { Link } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import { getTrial as actionGetTrial } from '../../actions/user';
import { needsAuth } from '../utils/authHoc';

import './Shop.jsx.scss';
import { isSubsValid } from '../../actions/utils';

const TrialError = ({ errorKey }) => (
  <div className="col-xs-12">
    <h3 className="sub-title"> {I18n.t('shop.trial.errorTitle')} </h3>

    <Translate className="text" value={`shop.trial.${errorKey}`} />
    <br />

    <Link
      className="btn btn-flat btn-flat-green btn-flat-rounded"
      to="/i"
      style={{ marginTop: '8em' }}
    >
      {I18n.t('shop.trial.goToSelectLesson')}
    </Link>
  </div>
);

const Trial = ({ isSubscribed, isTrialExpired, getTrial }) => (
  <div className="container-fluid new-style shop-cart">
    <div className="row cart-block centered">
      {!isSubscribed &&
        !isTrialExpired && (
          <div className="col-xs-12">
            <h3 className="sub-title">{I18n.t('shop.trial.title')}</h3>

            <div className="text">
              <Translate value="shop.trial.desc" dangerousHTML />
            </div>

            <div className="price">
              <Translate value="shop.trial.free" />{' '}
            </div>
            <button
              className="btn btn-flat btn-flat-green btn-flat-rounded"
              onClick={getTrial}
            >
              {I18n.t('shop.trial.activate')}
            </button>
          </div>
        )}

      {isTrialExpired && !isSubscribed && <TrialError errorKey="expired" />}

      {isSubscribed && <TrialError errorKey="subscribed" />}
    </div>
  </div>
);

const mapStateToProps = state => {
  const {
    auth: { user }
  } = state;

  const isSubscribed = isSubsValid(user);
  const isTrialExpired = !isSubscribed && user.subs && user.subs.trial;

  return {
    isSubscribed,
    isTrialExpired
  };
};

const mapDispatchToProps = dispatch => ({
  getTrial: () => dispatch(actionGetTrial())
});

export default compose(
  needsAuth,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Trial);
